import { useState, useEffect } from 'react';
import GridCell from '../MainGrid/GridCell';
import { domainForHunt, formatLabel } from '../../lib/huntDomain';
import styles from './SharedView.module.css';
import gridStyles from '../MainGrid/MainGrid.module.css';

const FUNCTIONS_URL = process.env.REACT_APP_FUNCTIONS_URL
  || 'https://us-central1-but-no-one-got-hurt.cloudfunctions.net';

export default function SharedView({ token }) {
  const [status, setStatus] = useState('loading'); // 'loading' | 'notfound' | 'ready'
  const [photos, setPhotos] = useState([]);
  const [hunt, setHunt] = useState(null);

  useEffect(() => {
    fetch(`${FUNCTIONS_URL}/getSharedCollection?token=${encodeURIComponent(token)}`)
      .then(res => {
        if (res.status === 404) { setStatus('notfound'); return null; }
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => {
        if (!data) return;
        setPhotos(data.photos);
        setHunt(data.hunt);
        setStatus('ready');
      })
      .catch(() => setStatus('notfound'));
  }, [token]);

  if (status === 'loading') {
    return (
      <div className={styles.center}>
        <p className={styles.muted}>Loading…</p>
      </div>
    );
  }

  if (status === 'notfound' || !hunt) {
    return (
      <div className={styles.center}>
        <h1 className={styles.wordmark}>Photo Hunter</h1>
        <p className={styles.muted}>This share link is no longer active.</p>
      </div>
    );
  }

  // Build derived maps, seeded with the shared hunt's item domain
  const photosByItem = new Map();
  for (const key of domainForHunt(hunt, photos)) photosByItem.set(key, []);
  for (const p of photos) {
    const arr = photosByItem.get(p.itemKey) ?? [];
    arr.push(p);
    photosByItem.set(p.itemKey, arr);
  }

  const primaryByItem = new Map();
  for (const [key, arr] of photosByItem) {
    primaryByItem.set(key, arr.find(p => p.isPrimary) ?? arr[0] ?? null);
  }

  const captured = [...photosByItem.values()].filter(a => a.length > 0).length;

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <span className={styles.wordmark}>{hunt.title}</span>
        <span className={styles.stats}>{captured}<span className={styles.statsSlash}>/{photosByItem.size}</span></span>
      </header>
      <p className={styles.badge}>VIEW ONLY</p>

      <div className={gridStyles.grid}>
        {[...photosByItem.keys()].map(key => (
          <GridCell
            key={key}
            itemKey={key}
            label={formatLabel(hunt.type, key)}
            photos={photosByItem.get(key)}
            primaryPhoto={primaryByItem.get(key)}
            isInHuntList={false}
            isShared={false}
            onClick={null}
          />
        ))}
      </div>
    </div>
  );
}
